export const ScheduleStatus = [
  { id: "0", name: "Pending" },
  { id: 1, name: "Not Started" },
  { id: 2, name: "In Progress" },
  { id: 3, name: "Partially Completed" },
  { id: 4, name: "Completed" },
  { id: 5, name: "Missed" },
  { id: 6, name: "Cancelled" },
  { id: 7, name: "Late" },
];
